import constants from "../../../../../appConstants";
import {
  MultiSelectFilter,
  DateTimeFilter,
  StaticFilter,
} from '@dataGrid/components/columnFilters';
import { TimeRangeEditor, NumericEditor } from '@dataGrid/components/cellEditors';
import { pickupTypeValueGetter } from "../../../../modules/Dispatch/RouteExecution/Pickups/PickupManagement/utils";
import PickupTypesRenderer from "../../../../modules/Dispatch/RouteExecution/Pickups/Grid/cellRenderer/PickupTypesRenderer";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ featureFlags }) {
    return GridConfig.getDefaultConfiguration(featureFlags);
  }
  static CommandCellRenderer(props) {
    return (
      <div
       className="ShipperName"
      >
        <b>{props.data.shipperName}</b>
        <br></br>
        {props.data.shipperAddress}
        <br></br>
        {props.data.shipperCity}, {props.data.shipperState}{" "}
        {props.data.shipperZip}
      </div>
    );
  }
  static pickupWindowValueGetter(rowNode) {
    return `${rowNode.data.pickupReadyTime} - ${rowNode.data.pickupCloseTime}`;
  }

  static pickupWindowValueSetter(rowNode) {
    if (rowNode.newValue === rowNode.oldValue) {
      return false;
    }
    const [startTime, endTime] =
      rowNode.newValue && rowNode.newValue.split("-");
    rowNode.data["pickupReadyTime"] = startTime;
    rowNode.data["pickupCloseTime"] = endTime;
    return true;
  }
  static isFirstColumn(params) {
    const displayedColumns = params.api.getAllDisplayedColumns();
    return displayedColumns[0] === params.column;
  }
  static getPickupTypeOptions(params) {
    return params.context?.pickupTypeOptions ?? [];
  }
  static getDefaultConfiguration(featureFlags) {
    return {
      title: "Pickups for Optimization",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        lockPinned: true,
        sortable: true,
        filter: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Pickup Name",
          headerTooltip: "Pickup Name",
          minWidth: constants.columnWidth.OPTIMIZATION_PICKUP_NAME,
          headerClass: "headerCellStyle",
          cellClass: "pickupNameCellClass",
          lockPosition: true,
          field: "shipperName",
          cellRenderer: GridConfig.CommandCellRenderer,
          filter: MultiSelectFilter,
          headerCheckboxSelection: GridConfig.isFirstColumn,
          checkboxSelection: GridConfig.isFirstColumn,
        },
        {
          headerName: "Pickup Window",
          headerTooltip: "Pickup Window",
          field: "pickupWindow",
          minWidth: constants.columnWidth.OPTIMIZATION_DELIVERY_WINDOW,
          cellClass: "gridCell-leftAlign gridCell-alignCenter",
          valueGetter: GridConfig.pickupWindowValueGetter,
          valueSetter: GridConfig.pickupWindowValueSetter,
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.TIME,
            isFullRangeFilter: true,
          },
          editable: true,
          cellEditor: TimeRangeEditor,
          cellEditorPopup: true,
          suppressKeyboardEvent: (params) => params.editing,
          lockPosition: true,
        },
        {
          headerName: "PSE",
          field: "pse",
          headerTooltip: "PSE",
          minWidth: constants.columnWidth.OPTIMIZATION_PSE,
          cellClass: "gridCell-leftAlign gridCell-alignCenter",
          editable: true,
          lockPosition: true,
          filter: MultiSelectFilter,
          cellEditor: NumericEditor,
          hide: featureFlags.IsWeightBasedRoutingEnabled,
        },
        {
          headerName: "Type",
          headerTooltip: "Type",
          valueGetter: pickupTypeValueGetter,
          minWidth: constants.columnWidth.PICKUP_TYPE,
          cellClass: "gridCell-leftAlign",
          filter: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getPickupTypeOptions,
          },
          cellRenderer: PickupTypesRenderer,
        },
      ],
    };
  }
}
